<i class="fas fa-star default-indicator"
   [ngStyle]="{display: !isDefaultView? 'none': 'inline'}"
   (click)="setAsDefaultView()"
   [matTooltip]="isDefaultView? 'Default': 'Set as default'"
   matTooltipPosition="right"
   matTooltipClass="text-center"></i>
